import { comma, get_products } from '../../../lib/utils'

import Header from '../../components/Header.vue'
import PostComment from '../../components/PostComment3.vue'
import Comment from '../../components/Comment/Comment.vue'
import SortFilter from '../../components/SortFilter.vue'

export default {
	data: function(){
		return {
			isReady: false,
			commentList:[], //コメントリスト
			product: {
				name: '',
			},
			page: 0,
			isMore: true,
			isLoadingMore: false,
			isLoadingComments: false,
			commentRequestId: 0,
			hasFirstPage: false,
			commentLoadFailed: false,
			replies: {},
		}
	},

	mounted: async function(){
		//銘柄データ取得
		let prdObj = await get_products(false)
		this.product = prdObj.obj[this.$route.params.c_code]

		this.isReady = true

		//comments
		await this.getComments()
	},

	methods: {
		backToDetail: function(){
			this.$router.push({name: 'AppSearchDetail', params:{c_code: this.$route.params.c_code}})
		},

		delCb: async function(id){
			// 削除後の位置ずれを避け、先頭ページから取り直す。
			this.commentList = this.commentList.filter(c => c.id != id)
			await this.changeSort()
		},

		postDone: async function(params){
			let d = {
				c_code:   this.product.c_code,
				nickname: params.nickname,
				comment:  params.comment,
				c_theme:  params.c_theme,
			}
			const res = await this.$post('/webapi/client/comment/create', d, true)
			if(res.code != 0){
				alert(res.message)
				return false
			}
			this.$refs.postComment.close()

			// 投稿後は並び順とページの位置をサーバーに合わせる。
			await this.changeSort()
		},

		comma: function(num){
			return comma(num)
		},

		getComments: async function(){
			const requestId = ++this.commentRequestId
			this.isLoadingComments = true
			try {
				let sf = this.$refs.sortFilter
				let d = {
					c_code: this.$route.params.c_code,
					sort:   sf.sort,
					page:   this.page,
				}
				if(sf.cTheme != -1) d.c_theme = sf.cTheme
				let res
				try {
					res = await this.$post('/webapi/client/comment/search_detail', d, true)
				} catch(e) {
					if(requestId != this.commentRequestId) return true
					this.commentLoadFailed = true
					alert('コメントを取得できませんでした。もう一度お試しください。')
					return false
				}
				if(requestId != this.commentRequestId) return true
				if(res.code != 0){
					this.commentLoadFailed = true
					alert(res.message)
					return false
				}

				this.commentLoadFailed = false
				if(d.page == 0) this.hasFirstPage = true

				//10件未満になったらもっとみるを削除
				this.isMore = (res.list.length >= 10)

				//最初のページの場合はクリアする
				if(d.page == 0) this.commentList = []

				for(let i=0, l=res.list.length; i<l; i++){
					this.commentList.push(res.list[i])
				}

				//返信コメント
				const ids = this.commentList.map( (c) => c.id )
				try {
					res = await this.$post('/webapi/client/reply/list', {comments_id: ids}, true)
					if(requestId == this.commentRequestId && res.code == 0) this.replies = res.replies
				} catch(e) {
					// コメントは取得済みなので、次回も同じページを追加しない。
				}
				return true
			} finally {
				if(requestId == this.commentRequestId) this.isLoadingComments = false
			}
		},

		changeSort: async function(){
			this.page = 0
			this.hasFirstPage = false
			this.isMore = true
			await this.getComments()
		},

		moreComments: async function(){
			if(this.isLoadingMore || this.isLoadingComments || (!this.isMore && !this.commentLoadFailed)) return
			this.isLoadingMore = true
			const previousPage = this.page
			const nextPage = this.hasFirstPage ? this.page + 1 : 0
			this.page = nextPage
			try {
				if(!await this.getComments() && this.page == nextPage) this.page = previousPage
			} finally {
				this.isLoadingMore = false
			}
		},

	},

	components: {
		Header,
		PostComment,
		Comment,
		SortFilter,
	},

}
